// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\JobOrder\ApiJobOrderSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { JobOrder, JobOrderData, JobOrderOptions } from 'data/models/JobOrder';
import { JobOrderVersion, JobOrderVersionData, JobOrderVersionOptions } from 'data/models/JobOrderVersion';

// JobOrderSelfData is the class that JobOrderSelf serializes to/from
export interface JobOrderSelfData {
    Id : number;
	
    Comments : CommentData[] | null;
    CommentsUrl : string | null;
    Events : EventData[] | null;
    Live : JobOrderData | null;
    Versions : JobOrderVersionData[] | null;
	
}

// JobOrderSelfOptions is the class which may be passed to the JobOrderSelf constructor to define optional initial data values
export interface JobOrderSelfOptions {
    Id : number;
	
    Comments? : CommentOptions[] | null;
    CommentsUrl? : string | null;
    Events? : EventOptions[] | null;
    Live? : JobOrderOptions | null;
    Versions? : JobOrderVersionOptions[] | null;
	
}

export class JobOrderSelf {
    public Id : DataSignal<number>;
	
    public Comments : SDataArray<Comment>;
    public CommentsUrl : DataSignal<string | null>;
    public Events : SDataArray<Event>;
    public Live : DataSignal<JobOrder | null>;
    public Versions : SDataArray<JobOrderVersion>;
	

    constructor();
    constructor(data : JobOrderSelfOptions);
    constructor(data: JobOrderSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Comments = SArray<Comment>([]);
        this.CommentsUrl = jsonableObservable(S.value<string | null>(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.Events = SArray<Event>([]);
        this.Live = S.value<JobOrder | null>(null);
        this.Versions = SArray<JobOrderVersion>([]);
	    
    }

    static key(obj : JobOrderSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : JobOrderSelfOptions) {
        return obj.Id;
    }

    static update(obj : JobOrderSelf, data : JobOrderSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CommentsUrl !== undefined) obj.CommentsUrl(data.CommentsUrl);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/JobOrderSelf.ts